// extracted by mini-css-extract-plugin
export var dividerContainer = "_9s-0";
export var line = "_9s-1";